import React, { FC } from 'react';

export interface TermsTextAreaProps {
  terms: string;
}

export const TermsTextArea: FC<TermsTextAreaProps> = ({ terms }) => {
  const color = '#0066FF';

  return (
    <>
      <div className="root relative box-border block h-[260px] w-full rounded-[12px] bg-white ring-1 ring-gray-200 transition-all focus-within:ring-2">
        <textarea
          defaultValue={terms}
          readOnly
          className="rs-font text-16 pc:text-15 box-border block h-full w-full resize-none rounded-[12px] border-none bg-transparent p-2 font-normal outline-none focus:outline-none"
        />
      </div>
      <style jsx>{`
        .root:focus-within {
          --tw-ring-color: ${color};
        }
      `}</style>
    </>
  );
};
